import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { CardTableComponent } from "src/app/components/cards/card-table/card-table.component";
import { ListColumn } from "src/app/models/list-columns.model";
import { OperadoresService } from "../operadores.service";
import * as dayjs from "dayjs";
import { AlertasSwalService } from "src/app/services/alerts.service";

@Component({
  selector: "app-modal-log-assings",
  templateUrl: "./modal.component.html",
})
export class HistorialAsignacionesModal implements OnInit {
  public defaults?: any = undefined;
  public columns: ListColumn[] = [
    {
      name: "No Control",
      property: "NoControl",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "Rol",
      property: "Rol",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "Fecha creado",
      property: "FechaCreado",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "Accion",
      property: "CausaCerraro",
      visible: true,
      isModelProperty: true,
    },
  ];
  list: any[] = [];

  first = true;

  @ViewChild(CardTableComponent, { static: true })
  public tableComp: CardTableComponent;
  constructor(
    public service: OperadoresService,
    private alerts: AlertasSwalService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}
  ngOnInit(): void {
    this.loadRecords();
  }

  loadRecords() {
    this.service.getHistorialAssigns(this.data).subscribe(
      (resultData) => {
        let mapped = resultData.map((m) => {
          return {
            ...m,
            CausaCerraro:
              m.CausaCerraro == "R"
                ? "Reasignar"
                : m.CausaCerraro == "E"
                ? "Entregado"
                : "Desasignar",
            FechaCreado: m.FechaCreado
              ? dayjs(m.FechaCreado).format("DD/MM/YYYY")
              : "",
          };
        });
        this.tableComp.setData(mapped);
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );
  } 
}
